// * ========================================================================
// * Mobile navigation functionality
// * ========================================================================

'use strict';

import $ from 'jquery';

var initNav = (function() {

  function bindNavClicks(){
    //add click event handler for mobile nav
    $('.js-nav__li.has-children:not(".bound")').addClass('bound').click(function(){
      $(this).find('ul').toggleClass('open');
    });
  }

  function init(){

    var $extranetNav = $('.js-nav-extranet');
    var $mainNav = $('.js-nav-main');
    var $extranetNavToggle = $('.js-nav-toggle-extranet');
    var $mainNavToggle = $('.js-nav-toggle-main');

    //toggle language nav
    $('.js-mininav__item__language-menu-toggle').on('click', function (e) {
      e.preventDefault();
      $(this).siblings('select').toggleClass('active');
    });

    //toggle extranet nav
    $extranetNavToggle.click(function(){
      $extranetNav.toggle();
      $mainNav.hide();

      //for the closed/open toggle icon animation
      $('.js-mobile-nav-checkbox').prop('checked',false);
    });

    //toggle main nav
    $mainNavToggle.click(function(){
      $mainNav.toggle();
      $extranetNav.hide();
    });


    if($(window).width() < 1200){
      bindNavClicks();
    }
  }
  return {
    init: init
  }
})();

module.exports = initNav;

